<template>
    <div id="zoho-channel-detail">
        <AppBreadCrumb :paths="[{ title: 'Zoho Channel Detail' }]" :select="true" class="visitor-detail-bread-crumb">
        </AppBreadCrumb>
        <div class="wrapper" v-if="channel">
            <div class="toolbar">
                <div class="left">
                    <IconButton :on-click="() => $router.push('/integrations/zoho')">
                        <span class="material-icons"> chevron_left </span>
                    </IconButton>
                    <div class="icon-container">
                        <ZohoIcon />
                    </div>
                    <div class="name">Zoho Kanalı : {{ channel.name }}</div>
                </div>
                <div class="right">
                    <a-button type="danger" @click="deleteModal = true"
                        >{{ $t("whatsappChannel.deleteChannel") }}
                    </a-button>
                </div>
            </div>
            <div class="channel-content">
                <div class="left">
                    <ChannelMenu v-model="currentTab" />
                </div>
                <div class="page-content">
                    <div v-if="currentTab === ZohoMenuTypes.USER_MAPPING.id">
                        <ZohoUserMapping v-model="channel" />
                    </div>
                </div>
            </div>
        </div>

        <a-modal v-model="deleteModal" icon="exclamation-circle" title="Kanalı Sil" @cancel="deleteModal = false">
            <p>{{ $t("whatsappChannel.deleteChannel") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteZohoChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
import Vue from "vue";
import IconButton from "../../Settings/components/IconButton.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import ChannelMenu from "./ChannelMenu.vue";
import log2 from "../../../../utils/log2";
import ZohoMenuTypes from "./ZohoMenuTypes";
import AppBreadCrumb from "../../../../components/common/AppBreadCrumb.vue";
import ZohoUserMapping from "./ZohoUserMapping.vue";
import ZohoIcon from "../../Chatbot/pages/integrations/svg/ZohoIcon.vue";

const log = log2("ZohoChannelDetail.vue");
export default Vue.extend({
    name: "ZohoChannelDetail",
    components: {
        ChannelMenu,
        ZohoIcon,
        ZohoUserMapping,
        IconButton,
        AppBreadCrumb,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(ZohoMenuTypes).find((x) => x.path === path);
        return {
            currentTab: selected ? selected.id : "detail",
            loading: false,
            selectedChannelId: this.$route.params.id,
            deleteModal: false,
            channel: null,
            ZohoMenuTypes,
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            channels: (state) => state.channel.channels.filter((x) => x.type === "zoho"),
            siteId: (state) => _.get(state.site.site, "_id"),
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
            updateChannel: "channel/updateChannel",
        }),
        changePage(page) {
            this.currentTab = page;
        },
        deleteZohoChannel() {
            const channel = this.channel;
            this.deleteChannel(channel._id).then(() => {
                this.$router.push("/integrations/zoho");
            });
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.channel;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success(this.$t("message.channelUpdatedSucs"));
                        this.originalChannel = _.cloneDeep(this.channel);
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error(this.$t("message.failedUpdateChannel"));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
    mounted() {
        this.listChannels().then((channels) => {
            this.channel = channels.find((x) => x._id === this.selectedChannelId);
            this.originalChannel = _.cloneDeep(this.channel);
        });
    },
    watch: {
        channel: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.originalChannel);
                    if (isChanged) {
                        log("channel changed=>", val);
                        this.handleSave();
                    }
                }
            },
            deep: true,
        },
        currentTab(value) {
            const selected = Object.values(ZohoMenuTypes).find((x) => x.id === value);
            if (selected) {
                this.$router.push(`/integrations/zoho/${this.channel._id}/detail/${selected.path}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#zoho-channel-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .toolbar {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            border: 1px solid var(--color-border-default);

            .left {
                display: flex;
                align-items: center;
                gap: 5px;

                .name {
                    font-size: 18px;
                    font-weight: 700;
                }

                .icon-container {
                    width: 30px;
                    height: 30px;
                    display: flex;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    overflow: hidden;
                    position: relative;
                }
            }

            .right {
                display: flex;
                justify-content: flex-end;
                gap: 5px;
            }
        }

        .channel-content {
            display: flex;
            height: 100%;

            .left {
                width: 275px;
                height: 100%;

                .channel-menu {
                    width: 100%;
                }
            }

            .page-content {
                width: calc(100% - 275px);
                height: 100%;
            }
        }
    }
}
</style>
